import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=032e0236&scoped=true&"
import script from "./Products.vue?vue&type=script&lang=ts&"
export * from "./Products.vue?vue&type=script&lang=ts&"
import style0 from "./Products.vue?vue&type=style&index=0&id=032e0236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032e0236",
  null
  
)

export default component.exports